import React from 'react';
import styled from 'styled-components';

const Header = styled.h3`
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 1rem;
  letter-spacing: 0.1em;
  padding: 0px;
  margin: 0px;
`;

export default function HeaderInfoM(props) {
  const { name, limit, color, size, style } = props;
  let newName = name;
  if (limit && name.length > limit) {
    newName = newName.substring(0, limit) + '...';
  }
  return (
    <React.Fragment>
      <Header style={{ color, fontSize: size, ...style }}>{newName}</Header>
    </React.Fragment>
  );
}
